(() => {
  const links = [...document.querySelectorAll('[data-joa-design-inquiry], [data-joa-sms-message]')];
  if (!links.length) return;
  const selectedText = option => {
    if (!option) return 'Not selected';
    const select = option.querySelector('select.mw-option__control:not(.joa-option-quick-select)');
    if (select) return select.selectedOptions[0]?.textContent.trim() || 'Not selected';
    const input = option.querySelector('input.mw-option__control:checked');
    return input?.getAttribute('aria-label') || input?.closest('[data-joa-label]')?.dataset.joaLabel || 'Not selected';
  };
  function update() {
    const container = document.querySelector('.joa-product-form .mw-apo-container');
    for (const link of links) {
      const title = link.dataset.productTitle;
      const fields = [['Material', '.joa-option--metal'], ['Diamond Size', '.joa-option--diamond-size'], ['Color/Clarity', '.joa-option--clarity'], ['Ring Size', '.joa-option--ring-size']];
      const availableFields = fields.filter(([, selector]) => container?.querySelector(selector));
      const message = link.dataset.joaSmsMessage || `Hi, I’m interested in the ${title}! Here's what I've chosen so far:\n\n${availableFields.map(([name, selector]) => `${name}: ${selectedText(container.querySelector(selector))}`).join('\n')}`;
      const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      link.href = `sms:+16476919838${ios ? '&' : '?'}body=${encodeURIComponent(message)}`;
    }
  }
  document.addEventListener('joa:options-designed', update);
  document.addEventListener('change', update);
  links.forEach(link => { link.addEventListener('pointerdown', update); link.addEventListener('focus', update); link.addEventListener('click', update); });
  update();
})();

(() => {
  if (!location.pathname.includes('/products/')) return;
  const selected = option => {
    if(!option)return '';
    const select=option.querySelector('select.mw-option__control:not(.joa-option-quick-select)');
    if(select)return select.selectedOptions[0]?.textContent.trim()||'';
    const input=option.querySelector('input.mw-option__control:checked');
    return input?.getAttribute('aria-label')||input?.closest('[data-joa-label]')?.dataset.joaLabel||'';
  };
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]');if(!link)return;
    let url;try{url=new URL(link.href,location.origin);}catch{return;}
    if(url.origin!==location.origin||!url.pathname.endsWith('/pages/custom-ring-inquiry'))return;
    const container=document.querySelector('.joa-product-form .mw-apo-container');
    const fields={};
    for(const [name,selector]of [['Diamond size (ct)','.joa-option--diamond-size'],['Clarity & Color','.joa-option--clarity'],['Material','.joa-option--metal'],['Ring size','.joa-option--ring-size']]){
      const text=selected(container?.querySelector(selector));if(text&&!/not selected|select an option/i.test(text))fields[name]=text;
    }
    const engraving=document.querySelector('[data-engraving-property]:not(:disabled)');if(engraving?.value)fields.Engraving=engraving.value;
    const product=document.querySelector('.product-details h1')?.textContent.trim()||document.querySelector('h1')?.textContent.trim()||'';
    const data={product,fields,at:Date.now()};
    try{sessionStorage.setItem('joa-inquiry-prefill-v1',JSON.stringify(data));}catch{}
    url.searchParams.set('inquiry',JSON.stringify(data));link.href=url.href;
  });
})();
